import type { ZipEntry } from "../zip/zip";

/** URL segment the service worker serves open walks under: <scope>walk/<id>/<path>. */
export const WALK_ROUTE = "walk/";

/** What the page hands to the service worker so it can serve files from the open ZIP. */
export interface WalkSession {
  id: string;
  /** The picked file itself. Nothing is copied: entries are read as slices of it. */
  file: Blob;
  /** Folder inside the ZIP that holds scene.json ("" or "K_desktop/"). */
  root: string;
  entries: ZipEntry[];
}

export type PageToWorker =
  | { type: "walk-open"; session: WalkSession }
  | { type: "walk-close"; id: string }
  | { type: "diag" };

/** Sent by the worker when it was restarted and lost a session it is asked to serve. */
export interface WorkerToPage {
  type: "walk-need";
  id: string;
}

/** Where the worker got the bytes of a walk/ request from (Diagnostics panel). */
export type FetchSource = "precache" | "zip" | "session-missing" | "network" | "error";

/** One walk/ fetch the worker answered: path only (no query), status or error text. */
export interface FetchOutcome {
  t: number;
  path: string;
  result: string;
  source: FetchSource;
}

/** The worker's reply to `{ type: "diag" }` (an older worker just answers `{ ok: true }`). */
export interface WorkerDiag {
  version: string;
  startedAt: number;
  /** Ids of the walk sessions held in memory right now. */
  sessions: string[];
  /** Window clients this worker controls / can see at all. */
  clients: { controlled: number; all: number };
  /** The last walk/ fetches, oldest first. */
  fetches: FetchOutcome[];
}
